import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import SocketDevConfigListing from "./SocketDevConfigListing";
import SocketDevCredentialsForm from "./SocketDevCredentialsForm";

interface Props {
  // Add props type definition here if needed
}

export default function SocketDevPullAndPushView(props: Props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={SocketDevCredentialsForm}
      PullConfigListingView={SocketDevConfigListing}
      RunOnDemandButtonText={"Sync tool Applications"}
    />
  );
}
